<template>
    <div></div>
</template>

<script>
    import {getToken, setToken} from "../common/storage";

    export default {
        name: "Auth",
        created() {
            this.login();
        },
        methods: {
            login() {
                let path = this.$route.query.state;
                if(getToken()) {
                    this.$router.push(path);
                } else {
                    let code = this.$route.query.code;
                    this.$axios({
                        url: '/official/auth',
                        method: 'GET',
                        params: {code}
                    }).then(res => {
                        if(res.code == 0) {
                            setToken(res);
                            location.href = `${location.protocol}//${location.host}${path}`
                            // this.$router.push(path);
                        } else {
                            this.$toast(res.msg);
                        }
                    });
                }
            }
        }
    };
</script>

<style scoped>

</style>
